import React from "react";
import { motion, useReducedMotion } from "framer-motion";

type SectionRevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
};

export function SectionReveal({
  children,
  className = "",
  delay = 0,
}: SectionRevealProps) {
  const reduceMotion = useReducedMotion();

  if (reduceMotion) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12, margin: "0px 0px -40px 0px" }}
      transition={{ duration: 0.45, ease: "easeOut", delay }}
    >
      {children}
    </motion.div>
  );
}

type LandingSectionProps = {
  id: string;
  children: React.ReactNode;
  className?: string;
  revealDelay?: number;
  noPadding?: boolean;
};

export function LandingSection({
  id,
  children,
  className = "",
  revealDelay = 0,
  noPadding = false,
}: LandingSectionProps) {
  const paddingClass = noPadding ? "" : "py-14 md:py-20";

  return (
    <section
      id={id}
      className={`scroll-mt-24 ${paddingClass} ${className}`.trim()}
    >
      <SectionReveal delay={revealDelay}>{children}</SectionReveal>
    </section>
  );
}
